import React, { useState } from 'react';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { XMarkIcon } from '@heroicons/react/24/outline';

const CancelGroupModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading = false,
  entity 
}) => {
  const [reason, setReason] = useState('');
  const [comments, setComments] = useState('');

  const handleConfirm = () => {
    onConfirm({ reason, comments });
  };

  const handleClose = () => {
    setReason('');
    setComments('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Cancel"
      size="md"
    >
      <div className="py-4">
        <div className="flex items-center mb-4">
          <XMarkIcon className="h-12 w-12 text-red-500 mr-4" />
          <div>
            <h3 className="text-lg font-medium text-gray-900">
              Cancel Fulfillment Group?
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              This will cancel all items in this fulfillment group.
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <div>
            <label htmlFor="cancel-reason" className="block text-sm font-medium text-gray-700 mb-2">
              Reason for cancellation *
            </label>
            <select
              id="cancel-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent"
              required
            >
              <option value="">Select a reason</option>
              <option value="changed_mind">Changed my mind</option>
              <option value="found_better_price">Found better price elsewhere</option>
              <option value="ordered_by_mistake">Ordered by mistake</option>
              <option value="seller_delay">Seller taking too long</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div>
            <label htmlFor="cancel-comments" className="block text-sm font-medium text-gray-700 mb-2">
              Additional comments (optional)
            </label>
            <textarea
              id="cancel-comments"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              rows={3}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent"
              placeholder="Any additional details about your cancellation..."
            />
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4 mt-4">
          <h4 className="text-sm font-medium text-amber-900 mb-2">
            What happens next:
          </h4>
          <ul className="text-sm text-amber-800 space-y-1">
            <li>• All items in this group will be canceled</li>
            <li>• You will receive a full refund</li>
            <li>• The merchant will be notified</li>
            <li>• This action cannot be undone</li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row-reverse gap-3">
          <Button
            onClick={handleConfirm}
            disabled={isLoading || !reason}
            isLoading={isLoading}
            variant="danger"
            className="flex items-center justify-center"
          >
            <XMarkIcon className="h-4 w-4 mr-2" />
            Cancel
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            variant="secondary"
          >
            Keep Group
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelGroupModal; 